import { render, staticRenderFns } from "./ProvocativeTestsBlock.vue?vue&type=template&id=7d35653c&lang=pug&"
import script from "./ProvocativeTestsBlock.vue?vue&type=script&lang=js&"
export * from "./ProvocativeTestsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProvocativeTestsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports